export default __webpack_public_path__ + "static/media/Attachment.c331afc1.svg";